/* eslint-disable prefer-destructuring */
import { v4 as uuid } from 'uuid';

export const MAP_OUTPUT_FROM_WATSON = {
  TEXT: 'Texto simples',
  OPTION: 'Lista de opções',
};

const MAP_OUTPUT_TO_WATSON = {
  'Texto simples': 'text',
  'Lista de opções': 'option',
};

export default class DialogOutputDTO {
  constructor(output, isNew = false) {
    if (isNew) {
      this.id = uuid();
      this.type = output.type;

      if (this.type === MAP_OUTPUT_FROM_WATSON.TEXT) {
        this.values = [];
      }
      if (this.type === MAP_OUTPUT_FROM_WATSON.OPTION) {
        this.title = '';
        this.description = '';
        this.preference = 'dropdown';
        this.elements = [];
      }
    } else {
      this.type = MAP_OUTPUT_FROM_WATSON[output.type] || null;
      if (!this.type) {
        this.type = output.type;
        this.nonEditable = true;
      }
    }

    return {
      ...output,
      ...this,
    };
  }

  static buildList(outputs) {
    if (!outputs) return;
    return outputs.map((output) => new DialogOutputDTO(output));
  }

  static parseList(outputs) {
    if (!outputs) return null;
    return outputs.map((output) => {
      const type = !output.nonEditable && MAP_OUTPUT_TO_WATSON[output.type];
      return {
        ...output,
        type,
      };
    });
  }
}
